var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoutLargeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 124,
    viewBox: "0 0 122 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5735 61.5156C13.5735 71.0091 16.3886 80.2894 21.6629 88.183C26.9373 96.0766 34.4338 102.229 43.2047 105.862C51.9755 109.495 61.6267 110.445 70.9378 108.593C80.2489 106.741 88.8017 102.17 95.5146 95.4568C102.228 88.7438 106.799 80.191 108.651 70.88C110.503 61.5689 109.553 51.9177 105.92 43.1468C102.287 34.376 96.1344 26.8794 88.2409 21.6051C80.3473 16.3308 71.067 13.5156 61.5735 13.5156",
    stroke: "#3030AD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.956 46.4709C116.884 35.0083 110.483 24.714 101.561 16.8896C92.6388 9.06524 81.5969 4.06225 69.8316 2.51331C58.0662 0.964369 46.1058 2.93905 35.4627 8.18763C24.8196 13.4362 15.9719 21.723 10.0385 32C4.10504 42.277 1.35234 54.0827 2.12846 65.9242C2.90459 77.7656 7.1747 89.111 14.3988 98.5257C21.6229 107.94 31.4765 115.001 42.7136 118.816C53.9507 122.63 66.0666 123.027 77.5291 119.956",
    stroke: "#EBEBF9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3001 63.9975H65.1745V62.123H63.3001V63.9975ZM66.4241 63.9975H68.2981V62.123H66.4241V63.9975Z",
    fill: "#AFAFE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6991 93.9836L34.0262 88.2801V35.7113L55.6991 30.0078V93.9836ZM53.8247 32.439L35.9002 37.1561V86.8353L53.8247 91.5524V32.439Z",
    fill: "#3030AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0063 61.9962C45.0063 60.1656 46.4953 58.6758 48.3263 58.6758C50.1573 58.6758 51.6467 60.1656 51.6467 61.9962C51.6467 63.8272 50.1573 65.3166 48.3263 65.3166C46.4953 65.3166 45.0063 63.8272 45.0063 61.9962ZM46.8807 61.9962C46.8807 62.7939 47.5293 63.4422 48.3263 63.4422C49.124 63.4422 49.7727 62.7939 49.7727 61.9962C49.7727 61.1989 49.124 60.5506 48.3263 60.5506C47.5293 60.5506 46.8807 61.1989 46.8807 61.9962Z",
    fill: "#AFAFE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8502 54.4966H68.7242V36.1719H58.198V38.0463H66.8502V54.4966Z",
    fill: "#AFAFE9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8502 85.9445H58.198V87.8189H68.7242V71.7012H66.8502V85.9445Z",
    fill: "#AFAFE9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4581 63.0995L72.7402 50.3965V57.0588H58.198V58.9333H74.6146V54.1743L86.3603 63.0995L74.6146 72.0248V67.2666H58.198V69.1406H72.7402V75.8034L89.4581 63.0995Z",
    fill: "#3030AD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7977 54.4973H64.6721V40.2246H58.198V42.099H62.7977V54.4973Z",
    fill: "#AFAFE9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6721 71.7012H62.7977V81.8925H58.198V83.7665H64.6721V71.7012Z",
    fill: "#AFAFE9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoutLargeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logoutLargeIcon.5cac3c7e90517ed8e12a75a4cd9adc75.svg";